import React, { Component, Fragment } from 'react';
import DynamicOpenModalRuleForm from './DynamicOpenModalRuleForm';
import { getSnippetModalOptions } from '../../ActionFormUtils';

export default class DynamicOpenModalRule extends Component {
  getModalOptions = () => {
    const { snippets, snippetType } = this.props;
    let modalOptions = [];
    if (snippetType === 'SUB_PAGE') {
      const subPageSnippet = snippets.filter((snippet) => snippet.snippetType === 'SUB_PAGE');
      subPageSnippet.forEach((snippet) => {
        modalOptions.push({
          value: snippet.uuid,
          label: snippet.name,
        });
      });
    } else modalOptions = getSnippetModalOptions(snippets);
    return modalOptions;
  };

  render() {
    const { createNewParamRow, params, collectionFrom, snippetType, collectionFieldValueOptions } =
      this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left w-50">Field Value</td>
                <td className="text-left"> {snippetType === 'SUB_PAGE' ? 'Subpage' : 'Modal'} </td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <DynamicOpenModalRuleForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    collectionFieldValueOptions={collectionFieldValueOptions}
                    modalOptions={this.getModalOptions()}
                    collectionFrom={collectionFrom}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
